import type { CreateCourseDraft201LocalizedSectionsItem } from './createCourseDraft201LocalizedSectionsItem';

/**
 * 언어별 섹션 정보 매핑
 * @nullable
 */
export type CreateCourseDraft201LocalizedSections = {[key: string]: CreateCourseDraft201LocalizedSectionsItem[]} | null;
